import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule, DirectivesModule } from '../../common';
import { EquipmentsComponent } from './equipments.component';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { DeliveryStatusTrackingStatusModule } from '../delivery-status-tracking-status/delivery-status-tracking-status.module';
import { EquipmentMaterialsComponent } from './equipment-materials/equipment-materials.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [EquipmentsComponent, EquipmentMaterialsComponent],
  imports: [
    CommonModule,
    TranslateModule.forChild({}),
    PipesModule,
    DirectivesModule,
    MatCardModule,
    MatTableModule,
    DeliveryStatusTrackingStatusModule,
    SvgIconModule,
    MatTooltipModule,
  ],
  exports: [EquipmentsComponent],
})
export class EquipmentsModule {}
